import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const PanelledLeatherCoat = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.jackets.PanelledLeatherCoat.itemName}
      name={SS23.jackets.PanelledLeatherCoat.itemName}
      price={SS23.jackets.PanelledLeatherCoat.itemPrice}
      fabric={SS23.jackets.PanelledLeatherCoat.itemFabric}
      src={SS23.jackets.PanelledLeatherCoat.sizeChart}
      divId={SS23.jackets.PanelledLeatherCoat.shopifyDivId}
      mainId={SS23.jackets.PanelledLeatherCoat.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.jackets.PanelledLeatherCoat.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.jackets.PanelledLeatherCoat.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default PanelledLeatherCoat;
